export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const formatINR = (paise) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR" }).format((paise || 0) / 100);

export const errorText = (error, fallback) => {
  const detail = error?.response?.data?.detail;
  if (Array.isArray(detail)) return detail.map((d) => d.msg).join("; ");
  return detail || fallback;
};

export const quotationStatusColors = {
  draft: "bg-stone-100 text-stone-700",
  approved: "bg-blue-100 text-blue-700",
  paid: "bg-green-100 text-green-700",
  payment_review: "bg-orange-100 text-orange-700",
  cancelled: "bg-red-100 text-red-700",
};

export const paymentStateColors = {
  COMPLETED: "bg-green-100 text-green-700",
  PENDING: "bg-yellow-100 text-yellow-700",
  CREATING: "bg-stone-100 text-stone-700",
  FAILED: "bg-red-100 text-red-700",
  CREATE_FAILED: "bg-red-100 text-red-700",
  ACCEPTED: "bg-blue-100 text-blue-700",
};

export const paymentLink = (token) => `${window.location.origin}/pay/${token}`;
